import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Pesquisar ou criar um novo", -1)

import { mdiMagnify } from '@mdi/js'
import { ref, watch, computed } from 'vue'

type Item = {
  title: string
  value: number | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ComboBoxWithOther',
  props: {
    label: {},
    hint: {},
    modelValue: {},
    items: {},
    error: { type: Boolean },
    errorMessage: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const internalModel = ref<Item[]>([...props.modelValue])

const normalizeItem = (item: Item | string): Item => {
  if (typeof item === 'string') {
    return {
      title: item,
      value: null
    }
  }
  return item
}

watch(
  () => props.modelValue,
  (newVal) => {
    const isDifferent = JSON.stringify(newVal) !== JSON.stringify(internalModel.value)
    if (isDifferent) {
      internalModel.value = [...newVal]
    }
  }
)

watch(internalModel, (newVal) => {
  const normalized = newVal.map(normalizeItem)
  const isDifferent = JSON.stringify(normalized) !== JSON.stringify(props.modelValue)
  if (isDifferent) {
    emit('update:modelValue', normalized)
  }
})

const computedItems = computed<Item[]>(() => {
  const itemsSet = new Map<string | number, Item>()

  props.items.forEach((item) => {
    itemsSet.set(item.value ?? item.title, item)
  })

  internalModel.value.forEach((item) => {
    const key = item.value ?? item.title
    if (!itemsSet.has(key)) {
      itemsSet.set(key, item)
    }
  })

  return Array.from(itemsSet.values())
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_combobox = _resolveComponent("v-combobox")!

  return (_openBlock(), _createBlock(_component_v_combobox, {
    modelValue: internalModel.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalModel).value = $event)),
    items: computedItems.value,
    label: _ctx.label,
    hint: _ctx.hint,
    error: _ctx.error,
    "error-messages": _ctx.errorMessage,
    "hide-details": "auto",
    "custom-value": true,
    multiple: "",
    chips: "",
    clearable: "",
    "deletable-chips": "",
    "persistent-hint": "",
    "hide-selected": "",
    "hide-no-data": "",
    class: "w-full mt-4",
    "auto-grow": "",
    color: "primary20",
    theme: "light",
    variant: "outlined",
    density: "comfortable",
    "item-title": "title",
    "item-value": "value"
  }, {
    "prepend-item": _withCtx(() => [
      _createVNode(_component_v_list_item, {
        class: "text-sm text-gray-300",
        ripple: false,
        clickable: false,
        density: "comfortable"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item_title, { class: "d-flex align-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: _unref(mdiMagnify),
                size: "24px",
                class: "mr-2"
              }, null, 8, ["icon"]),
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    chip: _withCtx(({ item, props }) => [
      _createVNode(_component_v_chip, _mergeProps(props, { class: "bg-[#E2E2E9] text-black text-sm rounded-md px-1 py-1 border border-gray-500" }), {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(item.title), 1)
        ]),
        _: 2
      }, 1040)
    ]),
    _: 1
  }, 8, ["modelValue", "items", "label", "hint", "error", "error-messages"]))
}
}

})